module.exports = __webpack_public_path__ + "static/ProdLeft_4-dfa6f66f836e74bc49958bc2daabb92c.png";